import {
  useBuckets,
  useCreateBucket,
  useDeleteBucket,
  useDeleteFile,
  useFiles,
  useUploadFile,
} from "@shared/lib/supabase/use-storage";
import { toast } from "sonner";

export function useStorageBuckets() {
  const { data: buckets = [], isPending } = useBuckets();
  const createBucket = useCreateBucket();
  const deleteBucket = useDeleteBucket();

  async function handleCreateBucket(name: string, isPublic: boolean) {
    await toast.promise(createBucket.mutateAsync({ name, isPublic }), {
      loading: "Creating bucket...",
      success: `Bucket "${name}" created`,
      error: "Failed to create bucket",
    });
  }

  async function handleDeleteBucket(name: string) {
    await toast.promise(deleteBucket.mutateAsync(name), {
      loading: "Deleting bucket...",
      success: `Bucket "${name}" deleted`,
      error: "Failed to delete bucket",
    });
  }

  return {
    buckets,
    isPending,
    createBucket: handleCreateBucket,
    deleteBucket: handleDeleteBucket,
  };
}

export function useStorageFiles(bucket: string) {
  const { data: files = [], isPending } = useFiles(bucket);
  const uploadFile = useUploadFile(bucket);
  const deleteFile = useDeleteFile(bucket);

  async function handleUpload(file: File, path?: string) {
    await toast.promise(uploadFile.mutateAsync({ file, path }), {
      loading: `Uploading ${file.name}...`,
      success: `${file.name} uploaded`,
      error: "Failed to upload file",
    });
  }

  async function handleDelete(paths: string[]) {
    await toast.promise(deleteFile.mutateAsync(paths), {
      loading: "Deleting file...",
      success: "File deleted",
      error: "Failed to delete file",
    });
  }

  return {
    files,
    isPending,
    uploadFile: handleUpload,
    deleteFile: handleDelete,
  };
}
